import { render } from "./good-road-card-result.vue?vue&type=template&id=08730764&scoped=true&ts=true"
import script from "./good-road-card-result.vue?vue&type=script&lang=ts"
export * from "./good-road-card-result.vue?vue&type=script&lang=ts"

import "./good-road-card-result.vue?vue&type=style&index=0&id=08730764&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08730764"]])

export default __exports__